/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable max-len */
import { MinusOutlined, PlusOutlined } from '@ant-design/icons';
import { Input } from 'antd';
import React, { useEffect } from 'react';
import { Controller, UseFormReturn } from 'react-hook-form';
import { Button, Typography } from 'tfc-components';

import { PackageForm, IPackage } from '.';

interface Props {
  total: number;
  duration: 'monthly' | 'yearly';
  billingType: 'one-time' | 'subscription';
  readonly?: boolean;
  visiblePackages: { id: string; name: string; price: number; duration: number; quantity: number }[];
  width?: string;
  method?: UseFormReturn<PackageForm>;
  mainPackage: IPackage | null
}

const ChoosePackage: React.FC<Props> = ({
  billingType,
  total,
  duration,
  readonly,
  visiblePackages,
  width,
  method,
  mainPackage
}) => {
  const handleInputValue = (id: string, value: number) => {
    if (!id) return value;
    let newValue = value;

    if (duration === 'monthly' && billingType === 'one-time' && newValue < 3) {
      newValue = 3;
    }

    if (duration === 'yearly' && billingType === 'one-time') {
      newValue = 1; // luôn 1
    }

    return newValue;
  };

  useEffect(() => {
    if (billingType === 'one-time' && duration === 'monthly' && method) {
      visiblePackages?.forEach((item, idx) => {
        if (item?.duration && item?.duration < 3) {
          method.setValue(`addOns.${idx}.duration`, 3, { shouldDirty: true, shouldValidate: true });
        }
      });
    }
  }, [billingType, duration, method, visiblePackages]);

  useEffect(() => {
    if (mainPackage && billingType === 'one-time' && duration === 'monthly' && mainPackage?.duration < 3 && method) {
      method.setValue('packages.duration', 3, { shouldDirty: true, shouldValidate: true });
    }
  }, [billingType, duration, mainPackage, method]);

  const isEmpty = visiblePackages.length === 0;

  // lấy luôn giá trị trong form để đồng bộ readonly / editable
  const watchedPackages = method?.watch('addOns');

  return (
    <div className="p-checkout_productWrap">
      <Typography.Text fontweight="600" extendClasses="p-checkout_titleProduct fs-20x24">
        Product list
      </Typography.Text>

      <div className="p-checkout_table">
        {/* Header */}
        <div className="p-checkout_table_head">
          <div>Name</div>
          <div>Unit</div>
          <div>
            Duration (
            {duration === 'monthly' ? 'month' : 'year'}
            )
          </div>
          <div>Base price (VND)</div>
          <div>Total price (VND)</div>
        </div>

        {/* Rows */}
        {mainPackage && (
          <div className="p-checkout_table_row">
            {/* name */}
            <div>{mainPackage?.name || '--'}</div>

            {/* quantity */}
            <div className="p-checkout_table_quantity">
              {!readonly ? (
                <Controller
                  control={method?.control}
                  name="packages.quantity"
                  render={({ }) => (
                    <Typography.Text>1</Typography.Text>
                  )}
                />
              ) : (
                <Typography.Text extendClasses="p-checkout_table_inputText">
                  {mainPackage?.quantity}
                </Typography.Text>
              )}
            </div>

            {/* duration */}
            <div className="p-checkout_table_quantity">
              {!readonly && billingType === 'one-time' ? (
                <Controller
                  control={method?.control}
                  name="packages.duration"
                  render={({ field }) => (
                    <>
                      <Button
                        disabled={duration === 'monthly' ? field.value <= 3 : field.value <= 1}
                        extendClasses="p-checkout_table_button"
                        onClick={() => field.onChange(field.value - 1)}
                      >
                        <MinusOutlined />
                      </Button>
                      <Input
                        className="p-checkout_table_input"
                        style={{ width: '70px', textAlign: 'center' }}
                        value={field.value}
                        onChange={(e) => field.onChange(
                          handleInputValue(mainPackage?.id, Number(e.target.value) || 0)
                        )}
                      />
                      <Button
                        extendClasses="p-checkout_table_button"
                        onClick={() => field.onChange(field.value + 1)}
                      >
                        <PlusOutlined />
                      </Button>
                    </>
                  )}
                />
              ) : (
                <Typography.Text extendClasses="p-checkout_table_inputText">
                  {!mainPackage ? '--' : mainPackage?.duration}
                </Typography.Text>
              )}
            </div>

            {/* price */}
            <div>{mainPackage?.price?.toLocaleString('vi')}</div>

            {/* total */}
            <div style={{ width }} className="p-checkout_table_totalValue">
              {(mainPackage?.price * mainPackage?.duration * mainPackage?.quantity)?.toLocaleString('vi')}
            </div>
          </div>
        )}
        {visiblePackages?.length > 0 ? (
          visiblePackages.map((pkg, index) => {
            const { id, name, price } = pkg;
            const currentPkg = watchedPackages?.[index];
            const quantity = currentPkg?.quantity ?? pkg.quantity;
            const durationValue = currentPkg?.duration ?? pkg.duration;
            const totalPrice = price * (quantity ?? 1) * (durationValue ?? 1);
            return (
              <div className="p-checkout_table_row" key={id}>
                {/* name */}
                <div>{name || '--'}</div>

                {/* quantity */}
                <div className="p-checkout_table_quantity">
                  {!readonly ? (
                    <Controller
                      control={method?.control}
                      name={`addOns.${index}.quantity`}
                      render={({ field }) => (
                        <>
                          <Button
                            disabled={field.value <= 1}
                            extendClasses="p-checkout_table_button"
                            onClick={() => field.onChange(field.value - 1)}
                          >
                            <MinusOutlined />
                          </Button>
                          <Input
                            className="p-checkout_table_input"
                            style={{ width: '70px', textAlign: 'center' }}
                            value={field.value}
                            onChange={field.onChange}
                          />
                          <Button
                            extendClasses="p-checkout_table_button"
                            onClick={() => field.onChange(field.value + 1)}
                          >
                            <PlusOutlined />
                          </Button>
                        </>
                      )}
                    />
                  ) : (
                    <Typography.Text extendClasses="p-checkout_table_inputText">
                      {isEmpty ? '--' : quantity}
                    </Typography.Text>
                  )}
                </div>

                {/* duration */}
                <div className="p-checkout_table_quantity">
                  {!readonly && billingType === 'one-time' ? (
                    <Controller
                      control={method?.control}
                      name={`addOns.${index}.duration`}
                      render={({ field }) => (
                        <>
                          <Button
                            disabled={duration === 'monthly' ? field.value <= 3 : field.value <= 1}
                            extendClasses="p-checkout_table_button"
                            onClick={() => field.onChange(field.value - 1)}
                          >
                            <MinusOutlined />
                          </Button>
                          <Input
                            className="p-checkout_table_input"
                            style={{ width: '70px', textAlign: 'center' }}
                            value={field.value}
                            onChange={(e) => field.onChange(
                              handleInputValue(id, Number(e.target.value) || 0)
                            )}
                          />
                          <Button
                            extendClasses="p-checkout_table_button"
                            onClick={() => field.onChange(field.value + 1)}
                          >
                            <PlusOutlined />
                          </Button>
                        </>
                      )}
                    />
                  ) : (
                    <Typography.Text extendClasses="p-checkout_table_inputText">
                      {isEmpty ? '--' : durationValue}
                    </Typography.Text>
                  )}
                </div>

                {/* price */}
                <div>{isEmpty ? '--' : price?.toLocaleString('vi')}</div>

                {/* total */}
                <div style={{ width }} className="p-checkout_table_totalValue">
                  {isEmpty ? '--' : totalPrice?.toLocaleString('vi')}
                </div>
              </div>
            );
          })
        ) : !mainPackage ? (
          <div className="p-checkout_table_row">
            <div>--</div>
            <div>--</div>
            <div>--</div>
            <div>--</div>
            <div>--</div>
          </div>
        ) : null}

        {/* Footer total */}
        <div className="p-checkout_table_row p-checkout_table_total">
          <Typography.Text fontweight="600" extendClasses="p-checkout_table_totalLabel">
            Total
          </Typography.Text>
          <div />
          <div />
          <div />
          <Typography.Text
            fontweight="600"
            extendClasses="p-checkout_table_totalValue"
            style={{ width }}
          >
            {isEmpty && !mainPackage ? '--' : total?.toLocaleString('vi')}
          </Typography.Text>
        </div>
      </div>
    </div>
  );
};

export default ChoosePackage;
